import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FieldProps } from "formik";
import FormikFieldCustomProps from "../field/formikfieldcustomprops";
import {FormattedMessage, useIntl} from "react-intl";

const DropDownFormik: React.FC<FieldProps & FormikFieldCustomProps> = ({
  field: { name, value },
  form: { setFieldValue },
  ...props
}) => {
    const intl = useIntl();
    console.log("DropDownFormik",value);
  return (
    <UncontrolledDropdown className="visibility-dropdown" style={{marginRight:'5px'}}>
      <DropdownToggle className="dd-btn" style={{background:`${value ? '#6BAF78' : '#a5a8af' }`}}>
        <img src={`/icons/${value ? 'visible' : 'hidden'}-ico.svg`} alt={value ? 'Visible' : 'Hidden'} />
        <span style={{color: `${value ? '#fff' : '#fff' }` }}>{value ? `${intl.formatMessage({id:'visible'})}` : `${intl.formatMessage({id:'hidden'})}`}</span>
        <img src="/icons/chev-down-white.svg" alt="" />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => setFieldValue(name, true)}>{intl.formatMessage({id:'visible'})}</DropdownItem>
        <DropdownItem onClick={() => setFieldValue(name, false)}>{intl.formatMessage({id:'hidden'})}</DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default DropDownFormik;
